import { render, staticRenderFns } from "./BankLinkingHeader.vue?vue&type=template&id=286439ff&"
import script from "./BankLinkingHeader.vue?vue&type=script&lang=js&"
export * from "./BankLinkingHeader.vue?vue&type=script&lang=js&"
import style0 from "./BankLinkingHeader.vue?vue&type=style&index=0&id=286439ff&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports